import styled from 'styled-components'

export const RewardIconImage = styled.img.attrs(({ theme, source, variant }) => ({
  src: source || (variant === 'currency' ? theme.checkout?.rewards?.currencyButtonIcon : theme.checkout?.rewards?.sectionButtonIcon),
}))`
  height: 41px;
  width: 41px;
  border-radius: 21px;
`
